export enum TMSScriptPositionEnum {
  TMS_HEADER = 'TMS_HEADER',
  TAG_TOP_BODY = 'TAG_TOP_BODY',
  TAG_BOTTOM_BODY = 'TAG_BOTTOM_BODY',
  TAG_HEADER = 'TAG_HEADER'
}
